module.exports = __webpack_public_path__ + "register/img/DocuPetLogo-Cyan.8f765ce9.png";